import { render, staticRenderFns } from "./switch-company.vue?vue&type=template&id=9d91cce4&scoped=true&"
import script from "./switch-company.vue?vue&type=script&lang=js&"
export * from "./switch-company.vue?vue&type=script&lang=js&"
import style0 from "./switch-company.vue?vue&type=style&index=0&id=9d91cce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d91cce4",
  null
  
)

export default component.exports